import { useEffect } from 'react';
import dayjs from 'dayjs';

import { getCountdownDuration, WARN_LIVE_EVENT_AUTO_ENDING_BEFORE } from 'utils';
import { metaSelector } from 'store/selectors';
import { useStore, useToast } from 'hooks';

export const useAutoEndWarning = (props: { eventCode: string; show?: boolean }) => {
  const eventMeta = useStore(metaSelector(props.eventCode));
  const toast = useToast();

  useEffect(() => {
    if (!props.show) return () => {};

    const warningDate = dayjs(eventMeta.endDate).subtract(WARN_LIVE_EVENT_AUTO_ENDING_BEFORE);
    const countdown = getCountdownDuration(warningDate.toString());
    const timeout = setTimeout(() => {
      toast.warn('Event will be auto-ended soon', {
        id: 'EVENT_AUTO_END_WARNING',
        autoDismiss: false
      });
    }, countdown);

    return () => {
      clearTimeout(timeout);
    };
  }, [props.show, props.eventCode]);
};
